import { render, staticRenderFns } from "./Addresses.vue?vue&type=template&id=e5d8d652&scoped=true&"
import script from "./Addresses.vue?vue&type=script&lang=ts&"
export * from "./Addresses.vue?vue&type=script&lang=ts&"
import style0 from "./Addresses.vue?vue&type=style&index=0&id=e5d8d652&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d8d652",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
